import React from "react";
import { Col, Row } from "react-bootstrap";

export default function Summary_Scoreless_Header_Small({ item, isSub }) {
  // Compact name styles with smaller font size
  const nameStyle = {
    fontSize: isSub ? "13px" : "17px",
    fontWeight: "600",
    padding: "1px 6px",
    textAlign: "left",
    lineHeight: "1.1",
    display: "flex",
    alignItems: "center",
  };

  // Container style with borders
  const containerStyle = {
    borderLeft: "3px solid #f6c344",
    borderRight: "3px solid #f6c344",
    borderRadius: "6px",
    padding: "3px 8px",
    backgroundColor: "#e7e7e7",
  };

  return (
    <Row
      style={{
        height: "auto",
        marginBottom: "4px",
        padding: "0",
      }}
    >
      <div style={containerStyle}>
        <Row
          className="align-items-center justify-content-center"
          style={{ margin: "0", display: "flex", alignItems: "center" }}
        >
          <Col xs="auto" style={nameStyle}>
            {item.name}
          </Col>
        </Row>
      </div>
    </Row>
  );
}
